import "core-js/modules/es.array.push.js";
import { defineComponent, defineAsyncComponent, ref, computed, watch, provide, onMounted } from 'vue';
import imageText from '@/components/imageText.vue';
import googleMaps from '@/components/googleMaps';
import accordion from '@/components/accordion';
import lowCode from '@/components/lowCode';
import subscription from '@/components/subscription';
import richText from '@/components/richText';
import imgSwipers from '@/components/imgSwipers';
import images from '@/components/images';
import videos from '@/components/videos';
import navigation from '@/components/navigation';
import goodsGrid from '@/components/goodsGrid';
import texts from '@/components/texts';
import hotMap from '@/components/hotMap';
import goodsScroll from '@/components/goodsScroll';
import mimo_replace from '@/components/home/mimo-replace';
import news_m from '@/views/mobile/news_m';
import axios from "axios";
import { api } from "@/api/api";
import { useStore } from 'vuex';
import router from '@/router';
import { useHead } from '@vueuse/head';
export default {
  name: 'news',
  components: {
    imageText,
    googleMaps,
    accordion,
    lowCode,
    subscription,
    richText,
    imgSwipers,
    images,
    videos,
    navigation,
    goodsGrid,
    texts,
    hotMap,
    goodsScroll,
    mimo_replace,
    news_m
  },
  setup() {
    // 页面标题和其他元数据
    useHead({
      title: '米檬口腔-新闻资讯',
      meta: [{
        name: 'description',
        content: '米檬口腔最新发布的行业新闻、产品更新和品牌活动资讯。了解我们如何为牙科诊所提供数字化解决方案。'
      }, {
        property: 'og:title',
        content: '米檬口腔-新闻资讯'
      }, {
        property: 'og:url',
        content: 'https://www.mimodental.com/news'
      }]
    });
    const get_data = ref([]);
    const store = useStore(); // 该方法用于返回store 实例
    const Client = store.state.Client;
    const list = ref([]);
    const currentPage = ref(1); // 当前页码
    const pageSize = ref(10); // 每页显示的条目数
    // 装修列表
    let url = api.baseUrl + api.webDecor + '?id=52';
    // 新闻列表
    let newLIst = api.baseUrl + api.text + '?category=information';
    axios({
      url,
      method: "get"
    }).then(res => {
      let {
        data
      } = res;
      // console.log(data);
      if (data.data.background) {
        var d = document.getElementById("app");
        d.style.background = 'url(' + data.data.background + ')';
        if (data.data.backgroundFit == 'fill') {}
        d.style.backgroundSize = data.data.backgroundFit == 'fill' ? '100% 100%' : 'auto 100%';
        d.style.backgroundPosition = 'center', d.style.backgroundRepeat = 'no-repeat';
      }
      get_data.value = JSON.parse(data.data.editConfig);
      console.log(get_data.value);
    });
    axios({
      url: newLIst,
      method: "get"
    }).then(res => {
      let {
        data
      } = res;
      console.log(data);
      list.value = data.rows;
    });
    const details = e => {
      router.push({
        name: 'details',
        params: {
          id: e
        }
      });
    };

    // 处理页码变化
    const handlePageChange = page => {
      currentPage.value = page;
    };

    // 计算当前页的数据
    const paginatedList = computed(() => {
      const start = (currentPage.value - 1) * pageSize.value;
      const end = start + pageSize.value;
      return list.value.slice(start, end);
    });
    return {
      get_data,
      Client,
      list,
      paginatedList,
      handlePageChange,
      pageSize,
      details
    };
  }
};